import { articles } from '@/mocks/siteData';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function LatestFeed() {
  const sorted = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1));
  const gridItems = sorted.slice(0, 6);
  const listItems = sorted.slice(6);

  return (
    <>
      <section className="bg-background-100" aria-labelledby="latest-title">
        <div className="w-full px-4 py-12 md:px-6 md:py-16">
          <SectionHeading
            eyebrow="实时更新"
            title="最新爆料进展"
            description="每一条都标注了发布时间与围观数，仍在发酵的事件会持续补充新的节点。"
            moreTo="/category/all"
            moreLabel="进入最新爆料"
          />
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {gridItems.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </section>

      {listItems.length > 0 && (
        <section className="w-full px-4 py-12 md:px-6 md:py-16" aria-labelledby="more-title">
          <SectionHeading
            eyebrow="仍在发酵"
            title="持续围观中"
            description="这些事件的讨论还在继续，编辑团队会跟进新的回应与进展。"
          />
          <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
            {listItems.map((article) => (
              <ArticleCard key={article.id} article={article} variant="list" />
            ))}
          </div>
        </section>
      )}
    </>
  );
}